import { Map } from "immutable";
import {
  FETCH_ACCOUNT_SETTINGS_SUCCESS,
  FETCH_ACCOUNT_USED_STORAGE_SUCCESS,
  FETCH_SUBSCRIPTION_PLANS_SUCCESS,
} from "~/store/action_types";

const account_settings = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_ACCOUNT_SETTINGS_SUCCESS:
      if (!action.response) {
        return state;
      }
      state = state.merge(action.response);
      return state;
    case FETCH_ACCOUNT_USED_STORAGE_SUCCESS:
      if (!action.response) {
        return state;
      }
      state = state.set(`storage`, Map(action.response));
      return state;
    case FETCH_SUBSCRIPTION_PLANS_SUCCESS:
      if (action.response.result.plan) {
        state = state.updateIn(["plan"], (plan) =>
          (Map.isMap(plan) ? plan : Map()).set("name", action.response.result.plan)
        );
      }
      if (action.response.result.billing_period) {
        state = state.updateIn(["plan"], (plan) =>
          (Map.isMap(plan) ? plan : Map()).set("billing_period", action.response.result.billing_period)
        );
      }
      return state;
    default:
      return state;
  }
};

export default account_settings;
